/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Presentation_Template_Drop_Only_FirstInputs */



/**
* | output |
* | --- |
* | "One template at a time — using “{name}” and ignoring the rest." |
*
* @param {Presentation_Template_Drop_Only_FirstInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const presentation_template_drop_only_first = /** @type {((inputs: Presentation_Template_Drop_Only_FirstInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Presentation_Template_Drop_Only_FirstInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Nur eine Vorlage auf einmal – „${i?.name}“ wird verwendet, der Rest ignoriert.`)
	return /** @type {LocalizedString} */ (`One template at a time — using “${i?.name}” and ignoring the rest.`)
});